
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/modern-slavery-statement",
      function () {
        return require("private-next-pages/modern-slavery-statement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/modern-slavery-statement"])
      });
    }
  